<template>
  <div>
    <div v-if="errorAutoAssign && errorAutoAssign.length">
      <b-alert
        :show="errorAutoAssign && errorAutoAssign.length ? true : false"
        variant="danger"
      >
        <div v-if="Array.isArray(errorAutoAssign)">
          <div
            class="d-flex flex-column my-1"
            v-for="(error_text, index) in errorAutoAssign"
            :key="index"
          >
            {{ error_text }}
          </div>
        </div>
        <div v-else>
          <div v-html="errorAutoAssign || '&nbsp;'"></div>
        </div>
      </b-alert>
    </div>
    <div v-if="importError && importError.length">
      <b-alert
        :show="importError && importError.length ? true : false"
        variant="danger"
        dismissible
        @dismissed="importError = null"
      >
        <div v-html="importError || '&nbsp;'"></div>
      </b-alert>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3">
      <QuickSearchHeader @search="search" />
      <div class="d-flex align-items-center justify-content-end">
        <div v-if="showAutoAssignFunction">
          <base-button
            id="InsuranceCompany-add-btn"
            variant="secondary"
            :cus_style="exportBtnStyle"
            :class="['mt-1 px-4']"
            @click="showAutoAssignModal"
            :disabled="loadingAutoAssign || disableAutoAssign"
          >
            <div v-if="loadingAutoAssign">
              <b-spinner style="width: 1rem; height: 1rem"></b-spinner>
            </div>
            <div v-else>
              <img
                src="@/assets/images/icons/add-icon.svg"
                alt="add-icon"
                class="mx-1"
              />
            </div>
            <span>
              {{ $t("auto-assign") }}
            </span>
          </base-button>
        </div>
        <div>
          <base-button
            variant="secondary"
            :class="['mt-1 px-4 mx-2']"
            :cus_style="addBtnStyle"
            @click="toggleDeadheadTrips"
          >
            <input
              class="me-2"
              type="checkbox"
              :checked="search_payload.is_dead_head"
              @click.stop="toggleDeadheadTrips"
            />
            <span>
              {{ $t("show-deadhead-trips") }}
            </span>
          </base-button>
        </div>
        <div>
          <base-button
            variant="secondary"
            :class="['mt-1 px-4 mx-2']"
            :cus_style="addBtnStyle"
            @click="$router.push('/deadhead-trip')"
            v-if="!$route?.query?.clientID"
          >
            <img
              src="@/assets/images/icons/add-icon.svg"
              alt="add-icon"
              class="mx-1"
            />
            <span>
              {{ $t("create-deadhead-trip") }}
            </span>
          </base-button>
        </div>
        <div class="mx-2">
          <base-button
            id="InsuranceCompany-add-btn"
            variant="secondary"
            :cus_style="exportBtnStyle"
            :class="['mt-1 px-4']"
            @click="download"
          >
            {{ $t("export") }}
            <img
              class="export-icon"
              src="@/assets/images/icons/export-icon.svg"
            />
          </base-button>
        </div>
        <div>
          <base-button
            id="import-trips-btn"
            variant="secondary"
            :cus_style="importBtnStyle"
            :class="['mt-1 px-4']"
            @click="triggerImport"
            :disabled="loadingImport"
          >
            <b-spinner v-if="loadingImport" style="width:1rem;height:1rem" />
            <span v-else>{{ $t("import") }}</span>
            <img
              v-if="!loadingImport"
              class="export-icon"
              src="@/assets/images/icons/export-icon.svg"
              style="transform:rotate(180deg)"
            />
          </base-button>
          <input
            ref="importFileInput"
            type="file"
            accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            style="display:none"
            @change="handleImportFile"
          />
        </div>
        <b-sidebar
          id="sidebar-backdrop"
          bg-variant="white"
          backdrop-variant="transparent"
          backdrop
          :right="!isLangRtl"
          shadow
          width="350px"
          @hidden="showDownloadFilters = false"
        >
          <filterSideBar
            :payload="search_payload"
            @filter-data="filterData"
            @reset-data="resetData"
            :showDownloadFilters="showDownloadFilters"
          />
        </b-sidebar>
      </div>
    </div>
    <b-tabs class="custom-nav-tabs" v-model="tabIndex" content-class="mb-3">
      <b-tab :title="$t('all')"> </b-tab>
      <b-tab :title="$t('updated')"> </b-tab>
      <b-tab :title="$t('upcoming')"> </b-tab>
      <b-tab :title="$t('canceled')"> </b-tab>
    </b-tabs>
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h5 class="result">{{ total }} {{ $t("results") }}</h5>
      <div @mouseenter="mouseenter" @mouseleave="mouseleave">
        <base-button
          variant="secondary"
          class="mx-2 filter__btn"
          :disabled="loading"
          cus_style="padding:10px"
          v-b-toggle.sidebar-backdrop
        >
          <img
            :src="
              filter_btn_hovered
                ? require(`@/assets/images/icons/funnel-simple-bold-svgrepo-com.png`)
                : require(`@/assets/images/icons/funnel-simple-bold-svgrepo-com.png`)
            "
            alt="funnel-simple"
          />
        </base-button>
      </div>
    </div>
    <div
      v-if="tabIndex !== 3"
      class="sub-status-list mb-3 d-flex align-items-between flex-wrap"
    >
      <div
        v-for="(sub_status, index) in sub_status_enum"
        :key="index"
        :class="[
          'sub-status',
          'me-3',
          { selected: search_payload.sub_status === sub_status.value },
        ]"
        @click="selectSubStatus(sub_status.value)"
      >
        <div class="icon me-2" :style="`background: ${sub_status.background}`">
          <img :src="sub_status.icon" alt="icon" />
        </div>
        <div>
          {{ $t(sub_status.label) }}
        </div>
      </div>
    </div>
    <base-spinner v-if="loading" />
    <div v-else>
      <b-alert :show="error && error.length ? true : false" variant="danger">
        <div v-if="Array.isArray(error)">
          <div
            class="d-flex flex-column my-1"
            v-for="(error_text, index) in error"
            :key="index"
          >
            {{ error_text }}
          </div>
        </div>
        <div v-else>
          <div v-html="error || '&nbsp;'"></div>
        </div>
      </b-alert>
      <data-table
        :items="items"
        :total="total"
        :perPage="perPage"
        :page="page"
        :sortBy="sortBy"
        :sortDesc="sortOrder"
        @change-page="changePage"
        @row-clicked="rowClicked"
        @sort-changed="handleSort"
      />
    </div>
    <b-sidebar
      :visible="show_detail"
      id="trip-detail-sidebar-backdrop"
      bg-variant="white"
      backdrop
      :right="!isLangRtl"
      shadow
      width="70%"
      @hidden="hidden"
    >
      <TripDetail
        v-if="show_detail"
        :id="trip_id"
        @update-flag="updateFlag"
        @change-tab="changeTab"
        @refetchData="getData"
      />
    </b-sidebar>
    <base-alert
      modalId="auto-assign-driver-warning-modal"
      icon="popup-warning-icon"
      :title="$t('auto-assign-mes')"
      :description="$t('auto-assign-confirmation')"
    >
      <template #buttons>
        <base-button
          id="auto-assign-driver-warning-modal-submit-btn"
          variant="primary"
          @click="autoAssign"
          class="col-3 mb-3"
        >
          {{ $t("yes") }}
        </base-button>
        <base-button
          id="auto-assign-driver-modal-cancel-btn"
          variant="secondary"
          @click="hideModal"
          class="col-3 mb-3"
        >
          {{ $t("no") }}
        </base-button>
      </template>
    </base-alert>
    <SuccessModal />
  </div>
</template>

<script>
import filterSideBar from "./filterSideBar";
import DataTable from "./dataTable.vue";
import TripDetail from "./detail.vue";
import TripService from "@/services/trip.service";
import moment from "moment";
import SuccessModal from "./SuccessModal";
import QuickSearchHeader from "./quickSearch.vue";
import { state } from "@/socket";

export default {
  components: {
    filterSideBar,
    DataTable,
    TripDetail,
    SuccessModal,
    QuickSearchHeader,
  },
  data() {
    return {
      loading: false,
      loadingAutoAssign: false,
      loadingImport: false,
      error: null,
      errorAutoAssign: null,
      importError: null,
      addBtnStyle: `padding:6px;font-weight: 600;width:175px;`,
      exportBtnStyle: `padding:6px;font-weight: 600;`,
      importBtnStyle: `padding:6px;font-weight: 600;`,
      filter_btn_hovered: false,
      perPage: 15,
      page: 1,
      assignList: [],
      search_payload: {
        _id: null,
        selected_journey_status: [],
        start_date: null,
        start_date_end: null,
        end_date: null,
        end_date_to: null,
        start_time: null,
        end_time: null,
        branch: [],
        category: [],
        service_category: [],
        sub_status: null,
        is_dead_head: true,
        contract: null,
        route: null,
      },
      quick_search_key: null,
      quick_search_value: null,
      items: [],
      total: 0,
      show_detail: null,
      trip_id: null,
      showDownloadFilters: false,
      tabIndex: 0,
      showAutoAssignBtn: false,
      sub_status_enum: [
        {
          label: "all-updates",
          value: null,
          icon: require(`@/assets/images/icons/file-1-icon.svg`),
          background: "var(--color-64)",
        },
        {
          label: "reviewed",
          value: "Reviewed",
          icon: require(`@/assets/images/icons/arrow-refresh-icon.svg`),
          background: "var(--color-92)",
        },
        {
          label: "approval-needed",
          value: "Approval-Needed",
          icon: require(`@/assets/images/icons/clock-1-icon.svg`),
          background: "var(--color-125)",
        },
        {
          label: "action-required",
          value: "Action-Required",
          icon: require(`@/assets/images/icons/alert-triangle-icon.svg`),
          background: "var(--color-124)",
        },
        {
          label: "archived",
          value: "Archived",
          icon: require(`@/assets/images/icons/archive-icon.svg`),
          background: "var(--color-131)",
        },
      ],
      sortOrder: true,
      sortBy: "-created_on",
    };
  },
  methods: {
    resolveTripDropoffName(trip) {
      const uid = String(trip?.uniqueServiceId || "");
      if (trip?.isDeadhead && uid.startsWith("HAJJ-GARAGE-TRANSFER")) {
        const fromPrint = String(trip?.hajjGarageTransferPrint?.destinationText || "").trim();
        if (fromPrint) return fromPrint;
      }
      return trip?.endLocation?.name;
    },
    quickSearch() {
      this.page = 1;
      this.getData();
    },
    search(key, value) {
      this.quick_search_key = key;
      this.quick_search_value = value;
      this.getData();
    },
    selectSubStatus(sub_status) {
      this.search_payload.sub_status = sub_status;
      this.quickSearch();
    },
    toggleDeadheadTrips() {
      this.search_payload.is_dead_head = !this.search_payload.is_dead_head;
      this.quickSearch();
    },
    changeTab(tab) {
      this.selectSubStatus(tab);
    },
    updateFlag(id) {
      this.items = this.items?.map((item) => {
        if (item._id === id) item["_rowVariant"] = null;
        return item;
      });
    },
    rowClicked(item) {
      this.show_detail = true;
      this.trip_id = item?._id;
    },
    hidden() {
      this.show_detail = false;
      this.trip_id = null;
    },
    setSearchValue(val, field) {
      this.search_payload[field] = val;
    },
    mouseenter() {
      this.filter_btn_hovered = true;
    },
    mouseleave() {
      this.filter_btn_hovered = false;
    },
    changePage(val) {
      this.page = val;
      this.getData();
    },
    filterData(resetData) {
      this.page = 1;
      this.getData(resetData);
    },
    resetData() {
      this.showAutoAssignBtn = false;
      this.search_payload = {
        _id: null,
        selected_journey_status: [],
        start_date: null,
        start_date_end: null,
        end_date: null,
        end_date_to: null,
        start_time: null,
        end_time: null,
        branch: [],
        category: [],
        service_category: [],
        sub_status: null,
        is_dead_head: true,
        contract: null,
        route: null,
        isDeadheadAllowance: false,
      };
      this.filterData("resetData");
    },
    async getData(resetData) {
      this.loading = true;
      this.error = null;
      this.errorAutoAssign = null;
      this.total = 0;
      this.items = [];

      let params = new URLSearchParams();
      let downloadParams = new URLSearchParams();
      if (this.quick_search_key && this.quick_search_value) {
        this.showAutoAssign();
        if (
          this.quick_search_key === "client" ||
          this.quick_search_key === "branch" ||
          this.quick_search_key === "operationalID" ||
          this.quick_search_key === "employeeID"
        ) {
          params.append(this.quick_search_key, this.quick_search_value);
        } else {
          if (this.quick_search_key === "referenceNumber") {
            let valueAfterHash;

            if (this.quick_search_value.includes("#")) {
              const valueParts = this.quick_search_value.split("#");
              valueAfterHash = valueParts[1] || "";
            } else {
              valueAfterHash = this.quick_search_value;
            }
            params.append(this.quick_search_key, "*" + valueAfterHash + "*");
          } else {
            params.append(
              this.quick_search_key,
              "*" + this.quick_search_value + "*"
            );
          }
        }
      }
      if (this.search_payload) {
        if (!this.search_payload.is_dead_head) {
          params.append("isDeadhead", this.search_payload.is_dead_head);
          downloadParams.append("isDeadhead", this.search_payload.is_dead_head);
        }

        if (this.search_payload._id) {
          params.append("_id", "*" + this.search_payload._id + "*");
          downloadParams.append("_id", "*" + this.search_payload._id + "*");
          this.showAutoAssign();
        }

        if (this.search_payload.contract) {
          params.append("contract", this.search_payload.contract);
          downloadParams.append("contract", this.search_payload.contract);
        }

        if (this.search_payload.route) {
          params.append("route", this.search_payload.route);
          downloadParams.append("route", this.search_payload.route);
        }

        if (this.search_payload.selected_journey_status.length) {
          params.append(
            "status",
            "in:[" +
              this.search_payload.selected_journey_status?.map(
                (each) => each.value
              ) +
              "]"
          );
          downloadParams.append(
            "status",
            this.search_payload.selected_journey_status?.map(
              (each) => each.value
            )
          );
          this.showAutoAssign();
        }

        if (this.search_payload?.category?.length) {
          params.append(
            "reservationCategory",
            "in:[" +
              this.search_payload?.category?.map((each) => each.value) +
              "]"
          );
          downloadParams.append(
            "reservationCategory",
            this.search_payload?.category?.map((each) => each.value)
          );
          this.showAutoAssign();
        }
        if (this.search_payload?.service_category?.length) {
          params.append(
            "serviceCategory",
            "in:[" +
              this.search_payload?.service_category?.map((each) => each.value) +
              "]"
          );
          downloadParams.append(
            "serviceCategory",
            this.search_payload?.service_category?.map((each) => each.value)
          );
          this.showAutoAssign();
        }
        if (this.$store.getters["enums/user_info"].branch) {
          params.append(
            "branch",
            this.$store.getters["enums/user_info"].branch
          );
          downloadParams.append(
            "branch",
            this.$store.getters["enums/user_info"].branch
          );
          this.showAutoAssign();
        } else if (this.search_payload?.branch?.length) {
          params.append(
            "branch",
            "in:[" +
              this.search_payload?.branch?.map((each) => each.value) +
              "]"
          );
          downloadParams.append(
            "branch",
            this.search_payload?.branch?.map((each) => each.value)
          );
          this.showAutoAssign();
        }

        if (
          this.search_payload.start_date ||
          this.search_payload.start_date_end
        ) {
          this.showAutoAssign();
          if (this.search_payload.start_time) {
            const parts = this.search_payload.start_time.split(":");
            let d = moment(this.search_payload.start_date)
              .locale("en")
              .utc()
              .add(3, "hours")
              .hour(parseInt(parts[0], 10))
              .minute(parseInt(parts[1], 10))
              .second(parseInt(parts[2], 10))
              .toISOString();
            let e = moment(this.search_payload.start_date_end)
              .locale("en")
              .utc()
              .add(3, "hours")
              .hour(parseInt(parts[0], 10))
              .minute(parseInt(parts[1], 10))
              .second(parseInt(parts[2], 10))
              .toISOString();

            if (d) {
              params.append("scheduledStartTime", `gte:${d}`);
              downloadParams.append("scheduledStartDate_Start_Time", d);
            }

            if (e) {
              params.append("scheduledStartTime", `lte:${e}`);
              downloadParams.append("scheduledStartDate_End_Time", e);
            }
          }
          if (
            this.search_payload.start_date &&
            this.search_payload.start_date_end
          ) {
            let d = moment(this.search_payload.start_date)
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();
            let e = moment(this.search_payload.start_date_end)
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();
            params.append("scheduledStartDate", `gte:${d}`);
            params.append("scheduledStartDate", `lte:${e}`);
            downloadParams.append("scheduledStartDate_Start", d);
            downloadParams.append("scheduledStartDate_End", e);
          } else {
            let d = moment(
              this.search_payload.start_date ||
                this.search_payload.start_date_end
            )
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();

            params.append("scheduledStartDate", `gte:${d}`);
            downloadParams.append("scheduledStartDate_Start", d);
          }
        }

        if (this.search_payload.end_date || this.search_payload.end_date_to) {
          this.showAutoAssign();
          if (this.search_payload.end_time) {
            const parts = this.search_payload.end_time.split(":");
            let d = moment(this.search_payload.end_date)
              .locale("en")
              .utc()
              .add(3, "hours")
              .hour(parseInt(parts[0], 10))
              .minute(parseInt(parts[1], 10))
              .second(parseInt(parts[2], 10))
              .toISOString();
            let e = moment(this.search_payload.end_date_to)
              .locale("en")
              .utc()
              .add(3, "hours")
              .hour(parseInt(parts[0], 10))
              .minute(parseInt(parts[1], 10))
              .second(parseInt(parts[2], 10))
              .toISOString();

            if (d) {
              params.append("scheduledEndTime", `gte:${d}`);
              downloadParams.append("scheduledEndDate_Start_Time", d);
            }

            if (e) {
              params.append("scheduledEndTime", `lte:${e}`);
              downloadParams.append("scheduledEndDate_End_Time", e);
            }
          }
          if (this.search_payload.end_date && this.search_payload.end_date_to) {
            let d = moment(this.search_payload.end_date)
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();
            let e = moment(this.search_payload.end_date_to)
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();

            params.append("scheduledEndDate", `gte:${d}`);
            params.append("scheduledEndDate", `lte:${e}`);
            downloadParams.append("scheduledEndDate_Start", d);
            downloadParams.append("scheduledEndDate_End", e);
          } else {
            let d = moment(
              this.search_payload.end_date || this.search_payload.end_date_to
            )
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();

            params.append("scheduledEndDate", `gte:${d}`);
            downloadParams.append("scheduledEndDate_Start", d);
          }
        }

        if (this.search_payload.sub_status) {
          this.showAutoAssign();
          params.append("subStatus", this.search_payload.sub_status);
          downloadParams.append("subStatus", this.search_payload.sub_status);
        }
      }

      if (
        this.$store.getters["enums/user_info"].clientID ||
        this.$route?.query?.clientID
      ) {
        params.append(
          "client",
          this.$store.getters["enums/user_info"].clientID
            ? this.$store.getters["enums/user_info"].clientID
            : this.$route?.query?.clientID
            ? this.$route?.query?.clientID
            : null
        );
        downloadParams.append(
          "clientID",
          this.$store.getters["enums/user_info"].clientID
            ? this.$store.getters["enums/user_info"].clientID
            : this.$route?.query?.clientID
            ? this.$route?.query?.clientID
            : null
        );
      }

      if (this.showDownloadFilters && !resetData) {
        this.$store.dispatch(
          "enums/GET_TRIPS_FILE",
          new URLSearchParams(downloadParams)
        );
        this.$bvModal.show("trips-export-modal");
      }

      this.showDownloadFilters = false;

      params.append("page", this.page || 1);
      params.append("limit", this.perPage);
      params.append("sort", this.sortBy);
      params.append(
        "select",
        "reservation.referenceNumber,reservation.client.name,reservation.client.arabicName,reservation.created_by,reservation.category.name,reservation.category.arabicName,service.name,service.arabicName,service.category.name,service.category.arabicName,startLocation.name,endLocation.name,uniqueServiceId,hajjGarageTransferPrint.destinationText,scheduledStartDate,scheduledStartTime,scheduledEndDate,scheduledEndTime,driver.employeeID,secondaryDriver.employeeID,driver.mobileNumber,vehicle.operationalID,branch.name,branch.arabicName,status,subStatus,viewed,isDeadhead,contract.client.name,contract.client.arabicName,contract.referenceNumber,isDeadheadAllowance,contract.created_by"
      );

      try {
        let res;

        if (this.tabIndex === 0) res = await TripService.search(params);
        else if (this.tabIndex === 1)
          res = await TripService.get("updated", params);
        else if (this.tabIndex === 2)
          res = await TripService.get("upcomming", params);
        else if (this.tabIndex === 3)
          res = await TripService.get("cancelled", params);

        this.total = res?.total;
        this.items = res?.items?.map((each) => {
          const isReservation = !!each?.reservation;
          return {
            _rowVariant: each?.isDeadhead
              ? "danger"
              : each?.subStatus === "Approval-Needed"
              ? "success"
              : null,
            reservation: each?.reservation?._id || "---",
            client: isReservation
              ? this.isLangRtl
                ? each?.reservation?.client?.arabicName
                : each?.reservation?.client?.name
              : this.isLangRtl
              ? each?.contract?.client?.arabicName
              : each?.contract?.client?.name,
            sales_person: isReservation
              ? each?.reservation?.created_by
              : each?.contract?.created_by,
            reference_number: isReservation
              ? each?.reservation?.referenceNumber
              : each?.contract?.referenceNumber || "---",
            reservation_category: this.isLangRtl
              ? each?.reservation?.category?.arabicName
              : each?.reservation?.category?.name || "---",
            service: this.isLangRtl
              ? each?.service?.arabicName
              : each?.service?.name,
            service_category: this.isLangRtl
              ? each?.service?.category?.arabicName
              : each?.service?.category?.name,
            start: each?.startLocation?.name,
            end: this.resolveTripDropoffName(each),
            _id: each._id,
            scheduledStartDate: moment(each.scheduledStartDate)
              .locale("en")
              .utcOffset(0)
              .format("DD-MM-YYYY"),
            scheduledStartTime: moment(each.scheduledStartTime)
              .locale("en")
              .utcOffset(0)
              .format("HH:mm"),
            scheduledEndDate: each?.scheduledEndDate ? moment(each.scheduledEndDate)
              .locale("en")
              .utcOffset(0)
              .format("DD-MM-YYYY") : "---",
            scheduledEndTime:each?.scheduledEndTime ? moment(each.scheduledEndTime)
              .locale("en")
              .utcOffset(0)
              .format("HH:mm") : "---",
            driver: each?.driver?.employeeID || "---",
            secondaryDriver: each?.secondaryDriver?.employeeID || "---",
            driverMobileNumber: each?.driver?.mobileNumber || "---",
            vehicle: each?.vehicle?.operationalID || "---",
            status: each.status,
            branch: this.isLangRtl
              ? each?.branch?.arabicName
              : each?.branch?.name,
            sub_status: each.subStatus,
            isDeadheadAllowance: each.isDeadheadAllowance,
            contract: each?.contract?._id || "---",
          };
        });
      } catch ({ message }) {
        this.error = message;
      } finally {
        this.loading = false;
      }
    },
    download() {
      this.showDownloadFilters = true;
      this.$root.$emit("bv::toggle::collapse", "sidebar-backdrop");
    },
    triggerImport() {
      this.$refs.importFileInput.value = null;
      this.$refs.importFileInput.click();
    },
    async handleImportFile(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.loadingImport = true;
      this.importError = null;
      try {
        const res = await TripService.importTrips(file);
        this.$store.dispatch("enums/SHOW_TOASTER_POP", {
          message: `${this.$t("import-trip-started")} (Log ID: ${res.logId})`,
          variant: "success",
          title: this.$t("import"),
          duration: 8000,
          noCloseButton: false,
          noAutoHide: false,
        });
      } catch (err) {
        this.importError = err?.message || this.$t("import-trip-error");
      } finally {
        this.loadingImport = false;
      }
    },
    autoAssign() {
      this.errorAutoAssign = null;
      this.loadingAutoAssign = true;
      this.hideModal();
      let params = new URLSearchParams();
      params.append("isDeadhead", false);
      if (this.quick_search_key && this.quick_search_value) {
        if (
          this.quick_search_key === "client" ||
          this.quick_search_key === "branch" ||
          this.quick_search_key === "operationalID" ||
          this.quick_search_key === "employeeID"
        ) {
          params.append(this.quick_search_key, this.quick_search_value);
        } else {
          if (this.quick_search_key === "referenceNumber") {
            let valueAfterHash;

            if (this.quick_search_value.includes("#")) {
              const valueParts = this.quick_search_value.split("#");
              valueAfterHash = valueParts[1] || "";
            } else {
              valueAfterHash = this.quick_search_value;
            }
            params.append(this.quick_search_key, "*" + valueAfterHash + "*");
          } else {
            params.append(
              this.quick_search_key,
              "*" + this.quick_search_value + "*"
            );
          }
        }
      }
      if (this.search_payload) {
        if (this.search_payload._id) {
          params.append("_id", "*" + this.search_payload._id + "*");
        }

        if (this.search_payload.selected_journey_status.length) {
          params.append(
            "status",
            "in:[" +
              this.search_payload.selected_journey_status?.map(
                (each) => each.value
              ) +
              "]"
          );
        }

        if (this.search_payload?.category?.length) {
          params.append(
            "reservationCategory",
            "in:[" +
              this.search_payload?.category?.map((each) => each.value) +
              "]"
          );
        }
        if (this.search_payload?.service_category?.length) {
          params.append(
            "serviceCategory",
            "in:[" +
              this.search_payload?.service_category?.map((each) => each.value) +
              "]"
          );
        }
        if (this.$store.getters["enums/user_info"].branch) {
          params.append(
            "branch",
            this.$store.getters["enums/user_info"].branch
          );
        } else if (this.search_payload?.branch?.length) {
          params.append(
            "branch",
            "in:[" +
              this.search_payload?.branch?.map((each) => each.value) +
              "]"
          );
        }

        if (
          this.search_payload.start_date ||
          this.search_payload.start_date_end
        ) {
          if (this.search_payload.start_time) {
            const parts = this.search_payload.start_time.split(":");
            let d = moment(this.search_payload.start_date)
              .locale("en")
              .utc()
              .add(3, "hours")
              .hour(parseInt(parts[0], 10))
              .minute(parseInt(parts[1], 10))
              .second(parseInt(parts[2], 10))
              .toISOString();
            let e = moment(this.search_payload.start_date_end)
              .locale("en")
              .utc()
              .add(3, "hours")
              .hour(parseInt(parts[0], 10))
              .minute(parseInt(parts[1], 10))
              .second(parseInt(parts[2], 10))
              .toISOString();

            params.append("scheduledStartTime", `gte:${d}`);
            params.append("scheduledStartTime", `lte:${e}`);
          }
          if (
            this.search_payload.start_date &&
            this.search_payload.start_date_end
          ) {
            let d = moment(this.search_payload.start_date)
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();
            let e = moment(this.search_payload.start_date_end)
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();
            params.append("scheduledStartDate", `gte:${d}`);
            params.append("scheduledStartDate", `lte:${e}`);
          } else {
            let d = moment(
              this.search_payload.start_date ||
                this.search_payload.start_date_end
            )
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();

            params.append("scheduledStartDate", `${d}`);
          }
        }

        if (this.search_payload.end_date || this.search_payload.end_date_to) {
          if (this.search_payload.end_time) {
            const parts = this.search_payload.end_time.split(":");
            let d = moment(this.search_payload.end_date)
              .locale("en")
              .utc()
              .add(3, "hours")
              .hour(parseInt(parts[0], 10))
              .minute(parseInt(parts[1], 10))
              .second(parseInt(parts[2], 10))
              .toISOString();
            let e = moment(this.search_payload.end_date_to)
              .locale("en")
              .utc()
              .add(3, "hours")
              .hour(parseInt(parts[0], 10))
              .minute(parseInt(parts[1], 10))
              .second(parseInt(parts[2], 10))
              .toISOString();

            params.append("scheduledEndTime", `gte:${d}`);
            params.append("scheduledEndTime", `lte:${e}`);
          }
          if (this.search_payload.end_date && this.search_payload.end_date_to) {
            let d = moment(this.search_payload.end_date)
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();
            let e = moment(this.search_payload.end_date_to)
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();

            params.append("scheduledEndDate", `gte:${d}`);
            params.append("scheduledEndDate", `lte:${e}`);
          } else {
            let d = moment(
              this.search_payload.end_date || this.search_payload.end_date_to
            )
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();

            params.append("scheduledEndDate", `${d}`);
          }
        }

        if (this.search_payload.sub_status) {
          params.append("subStatus", this.search_payload.sub_status);
        }
      }
      TripService.post(
        {},
        "auto-assign-trips-with-status-booking-unassigned",
        params
      )
        .then((res) => {
          this.loadingAutoAssign = false;
          this.assignList = res;
          if (res !== 0) {
            this.$store.dispatch("enums/SHOW_TOASTER_POP", {
              message: this.$t("auto-assign-info"),
              variant: "info",
              title: this.$t("assign"),
              duration: 10000,
              noCloseButton: true,
              noAutoHide: false,
            });
          } else {
            this.$store.dispatch("enums/SHOW_TOASTER_POP", {
              message: this.$t("auto-assign-warning"),
              variant: "warning",
              title: this.$t("assign"),
              duration: 10000,
              noCloseButton: true,
              noAutoHide: false,
            });
            this.assignList = [];
          }
        })
        .catch((err) => {
          this.loadingAutoAssign = false;
          this.errorAutoAssign = err.message;
        });
    },
    showAutoAssign() {
      this.showAutoAssignBtn = true;
    },
    showAutoAssignModal() {
      this.$bvModal.show("auto-assign-driver-warning-modal");
    },
    hideModal() {
      this.$bvModal.hide("auto-assign-driver-warning-modal");
    },
    handleSort({ sortBy, sortDesc }) {
      this.sortBy = sortDesc ? sortBy : `-${sortBy}`;
      this.sortOrder = sortDesc;
      this.getData();
    },
  },
  computed: {
    showAutoAssignFunction() {
      const checkStatus = this.items?.some(
        (item) => item.status === "Booking-Un-Assigned"
      );
      return this.showAutoAssignBtn && checkStatus;
    },
    auto_assign_trip() {
      return state.auto_assign_trip;
    },
    disableAutoAssign() {
      return this.assignList?.length !== 0;
    },
  },
  watch: {
    $route(val) {
      if (val?.query?.id) {
        this.show_detail = true;
        this.trip_id = val?.query?.id;
      }
    },
    tabIndex: {
      handler() {
        this.selectSubStatus(null);
      },
      immediate: true,
    },
    auto_assign_trip(val) {
      if (val && val?.userID === this.$store.getters["enums/user_info"].userID)
        this.assignList = [];
      this.getData();
    },
  },
  mounted() {
    this.tabIndex = 0;
    if (this.$route?.query?.id) {
      this.show_detail = true;
      this.trip_id = this.$route?.query?.id;
    }
  },
  created() {
    this.$store.dispatch("enums/GET_BRANCH_ENUMS");
    this.$store.dispatch("enums/GET_CLIENT_ENUMS");
  },
  i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/manageTrips.json"),
      ar: require("@/services/i18n/locales/ar/manageTrips.json"),
    },
  },
};
</script>

<style lang="scss" scoped>
.export-icon {
  margin-inline-start: 10px;
  margin-inline-end: -3px;
}
</style>

<style lang="scss">
.sub-status-list {
  .sub-status {
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 0.375rem;
    border: 1px solid var(--color-84);
    background: var(--color-01);
    padding: 0.5rem;
    color: var(--color-61);
    font-size: 0.875rem;
    &.selected {
      background: var(--color-84);
      font-weight: 700;
    }
    .icon {
      display: flex;
      padding: 0.4375rem;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
    }
  }
}
</style>
